import { CultureInfo } from '../culture-info.model';
import { CultureInfoTeo } from './teo';

/**
 * @ignore
 */
export const CultureInfoTeoKE: CultureInfo = {
  name: 'teo-KE',
  displayName: 'Kiteso (Kenia)',
  iso3LanguageCode: 'teo',
  iso2LanguageCode: 'teo',
  ietfLanguageTag: 'teo-KE',
  parent: CultureInfoTeo
};
